function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "s"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 v30 h60 v-30 z"
}));

var _ref3 = /*#__PURE__*/React.createElement("clipPath", {
  id: "t"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#s)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0 v30 h60 v-30 z",
  fill: "#012169"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L60,30 M60,0 L0,30",
  stroke: "#fff",
  strokeWidth: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0 L60,30 M60,0 L0,30",
  clipPath: "url(#t)",
  stroke: "#C8102E",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,0 v30 M0,15 h60",
  stroke: "#fff",
  strokeWidth: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M30,0 v30 M0,15 h60",
  stroke: "#C8102E",
  strokeWidth: 6
}));

var SvgGbFlag = function SvgGbFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 30",
    width: 60,
    height: 30,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGbFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gb-flag.ec574831.svg";
export { ForwardRef as ReactComponent };